import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import MasterLayout from './components/MasterLayout';
import './App.css';
import './styles/modern.css';

import Home from './components/Home';
import Academics from './components/Academics';
import Catalog from './components/Catalog';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import Request from './components/Request';
import Application from './components/Application';

import EducationalRequirements from './components/catalog/EducationalRequirements';
import SchoolInformation from './components/catalog/SchoolInformation';
import Tuition from './components/catalog/Tuition'; 
import Admissions from './components/catalog/Admissions';
import SchoolPolicy from './components/catalog/SchoolPolicy';
import GeneralInformation from './components/catalog/GeneralInformation';
import CreditByPortfolio from './components/catalog/CreditByPortfolio';
import MissionStatement from './components/catalog/MissionStatement';

import DoctoralPrograms from './components/academics/DoctoralPrograms';
import DoctorMinistry from './components/academics/DoctorMinistry';
import DoctorBusinessAdmin from './components/academics/DoctorBusinessAdmin';
import DoctorPhilosophy from './components/academics/DoctorPhilosophy';
import HamiltonBusinessSchool from './components/academics/HamiltonBusinessSchool';
import MBAHealthManagement from './components/academics/MBAHealthManagement';
import CollegeOfSpiritualStudies from './components/academics/CollegeOfSpiritualStudies';
import DivisionChristianCounseling from './components/academics/DivisionChristianCounseling';
import CollegeGuidanceCounseling from './components/academics/CollegeGuidanceCounseling';
import MAChristianCounseling from './components/academics/MAChristianCounseling';
import MSGuidanceCounseling from './components/academics/MSGuidanceCounseling';
import MSCounseling from './components/academics/MSCounseling';
import CollegeEducation from './components/academics/CollegeEducation';
import CollegeGuidance from './components/academics/CollegeGuidance';
import AssociateEarlyEd from './components/academics/AssociateEarlyEd';
import BSEarlyEd from './components/academics/BSEarlyEd';
import MSEarlyEd from './components/academics/MSEarlyEd';
import EdAdmin from './components/academics/EdAdmin';
import DivisionBiblicalStudies from './components/academics/DivisionBiblicalStudies';
import MABiblicalStudies from './components/academics/MABiblicalStudies';
import MAOTStudies from './components/academics/MAOTStudies';
import MANTStudies from './components/academics/MANTStudies';
import MABiblicalLanguages from './components/academics/MABiblicalLanguages';
import MATheology from './components/academics/MATheology';
import MASystematicTheology from './components/academics/MASystematicTheology';
import MAHistoricalTheology from './components/academics/MAHistoricalTheology';
import MAContemporaryTheology from './components/academics/MAContemporaryTheology';
import MAChristianMinistry from './components/academics/MAChristianMinistry';
import MAChristianEducation from './components/academics/MAChristianEducation';
import MEdAdminSupervision from './components/academics/MEdAdminSupervision';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log("ErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children; 
  }
}

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<MasterLayout />}>
              <Route index element={<Home />} />
              <Route path="academics" element={<Academics />} />
              <Route path="academics/ma_christian_counseling" element={<MAChristianCounseling />} />
              <Route path="academics/college_guidance" element={<CollegeGuidanceCounseling />} />
              <Route path="academics/college_christian_studies" element={<CollegeOfSpiritualStudies />} />
              <Route path="academics/division_christian_counseling" element={<DivisionChristianCounseling />} />
              <Route path="academics/doctoral_programs" element={<DoctoralPrograms />} />
              <Route path="academics/dr_ministry" element={<DoctorMinistry />} />
              <Route path="academics/dr_business_admin" element={<DoctorBusinessAdmin />} />
              <Route path="academics/dr_philosophy" element={<DoctorPhilosophy />} />
              <Route path="academics/hamilton_business_school" element={<HamiltonBusinessSchool />} />
              <Route path="academics/mba_health_management" element={<MBAHealthManagement />} />
              <Route path="academics/ms_guidance_counseling" element={<MSGuidanceCounseling />} />
              <Route path="academics/ms_counseling" element={<MSCounseling />} />
              <Route path="academics/college_education" element={<CollegeEducation />} />
              <Route path="academics/college_guidance" element={<CollegeGuidance />} />
              <Route path="academics/ass_early_ed" element={<AssociateEarlyEd />} />
              <Route path="academics/bs_early_ed" element={<BSEarlyEd />} />
              <Route path="academics/ms_early_ed" element={<MSEarlyEd />} />
              <Route path="academics/ed_admin" element={<EdAdmin />} />
              <Route path="academics/division_biblical_studies_and_theology" element={<DivisionBiblicalStudies />} />
              <Route path="academics/ma_biblical_studies" element={<MABiblicalStudies />} />
              <Route path="academics/ma_ot_studies" element={<MAOTStudies />} />
              <Route path="academics/ma_nt_studies" element={<MANTStudies />} />
              <Route path="academics/ma_biblical_languages" element={<MABiblicalLanguages />} />
              <Route path="academics/ma_theology" element={<MATheology />} />
              <Route path="academics/ma_systematic_theology" element={<MASystematicTheology />} />
              <Route path="academics/ma_historical_theology" element={<MAHistoricalTheology />} />
              <Route path="academics/ma_contemporary_theology" element={<MAContemporaryTheology />} />
              <Route path="academics/ma_christian_ministry" element={<MAChristianMinistry />} />
              <Route path="academics/ma_christian_education" element={<MAChristianEducation />} />
              <Route path="academics/med_in_administration_and_supervision" element={<MEdAdminSupervision />} />

              <Route path="catalog" element={<Catalog />} />
              <Route path="catalog/mission_statement" element={<MissionStatement />} />
              <Route path="catalog/credit_by_portfolio" element={<CreditByPortfolio />} />
              <Route path="catalog/general_information" element={<GeneralInformation />} />
              <Route path="catalog/education_requirements" element={<EducationalRequirements />} />
              <Route path="catalog/school_information" element={<SchoolInformation />} />
              <Route path="catalog/admissions" element={<Admissions />} />
              <Route path="catalog/tuition" element={<Tuition />} />
              <Route path="catalog/school_policy" element={<SchoolPolicy />} />
              <Route path="about_us" element={<AboutUs />} />
              <Route path="services" element={<Services />} />
              <Route path="request" element={<Request />} />
              <Route path="application" element={<Application />} />

              {/* Add more routes here */}
            </Route>
          </Routes>
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;